import React, { useState } from 'react';
import styles from './ProductCard.module.css';
import { openWhatsAppOrder } from '../utils/whatsapp';

const ProductCard = ({ product, onAddToCart, onItemClick, cartList = [] }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  // Count occurrences of this product in cartList
  const productCount = cartList.reduce((count, item) => {
    return count + (item.item_id === product.item_id ? (item.quantity || 1) : 0);
  }, 0);

  const handleAddToCartClick = (e) => {
    e.stopPropagation();
    setIsAnimating(true);
    onAddToCart(product);
    setTimeout(() => {
      setIsAnimating(false);
    }, 300);
  };

  const handleWhatsAppOrderClick = (e) => {
    e.stopPropagation();
    openWhatsAppOrder(product);
  };

  const getImageSrc = () => {
    if (!product.photo_url) return '';
    if (product.photo_url.startsWith('http') || product.photo_url.startsWith('/')) {
      return product.photo_url;
    }
    if (product.photo_url.startsWith('img/') || product.photo_url.startsWith('./img/')) {
      return `/${product.photo_url.replace(/^\.\//, '')}`;
    }
    return `/img/${product.photo_url}`;
  };

  return (
    <div className={styles.card} onClick={() => onItemClick && onItemClick(product)} role="button" tabIndex={0} onKeyPress={() => onItemClick && onItemClick(product)}>
      {product.sale > 0 && (
        <div className={styles.saleBadge}>
          Sale {product.sale}%
        </div>
      )}
      <div className={styles.brand}>{product.brand}</div>
      <img
        src={getImageSrc()}
        alt={product.item_name}
        className={styles.productImage}
        draggable={false}
      />
      <div className={styles.productName}>{product.item_name}</div>
      <div className={styles.priceContainer}>
        <span>${product.sell_price}</span>
        {product.old_price && product.old_price !== 0 ? (
          <span className={styles.oldPrice}>${product.old_price}</span>
        ) : null}
      </div>
      {productCount > 0 && (
        <span className={styles.cartCountBadge}>
          {productCount}
        </span>
      )}
      <div className={styles.buttonRow}>
        <button
          onClick={handleAddToCartClick}
          className={`${styles.addToCartButton} ${isAnimating ? styles.animating : ''}`}
          type="button"
          title="Add to Cart"
          aria-label={`Add ${product.item_name} to cart`}
        >
          <i className="fa fa-cart-plus" aria-hidden="true"></i>
        </button>
        <button
          onClick={handleWhatsAppOrderClick}
          className={styles.whatsAppButton}
          type="button"
          aria-label={`Order ${product.item_name} via WhatsApp`}
        >
          <i className="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
